<template>
  <div
    class="page-wrapper"
    :class="{ 'page-wrapper--full-height': isFullHeight }"
  >
    <nav v-if="showNavbar" class="navbar">
      <div class="navbar-left">
        <img
          class="logo-navbar"
          src="/images/terrassa-logo-blanco.png"
          alt="Logo Terrassa"
        />
      </div>
      <div class="navbar-center" v-if="isLoggedIn">
        <span class="nav-link" @click="goVetlles">
          <font-awesome-icon icon="person" class="nav-icon" />
          Vetlles
        </span>
        <span class="nav-link" @click="goSales">
          <font-awesome-icon icon="house" class="nav-icon" />
          Sales
        </span>
      </div>
      <div class="navbar-right" v-if="isLoggedIn">
        <span class="nav-link" @click="logout">
          <font-awesome-icon icon="right-from-bracket" class="nav-icon" />
          Tancar sessió
        </span>
      </div>
    </nav>
    <main class="page" :class="{ 'page--full-height': isFullHeight }">
      <RouterView />
    </main>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();

    const isFullHeight = computed(() => route.meta.isFullHeight ?? false);
    const showNavbar = computed(() => route.meta.showNavbar ?? true);

    const isLoggedIn = ref(false);

    onMounted(async () => {
      try {
        await axios.get("/api/auth/status", { withCredentials: true });
        isLoggedIn.value = true;
      } catch {
        isLoggedIn.value = false;
      }
    });

    const goVetlles = () => {
      router.push({ name: "vetlles" });
    };

    const goSales = () => {
      router.push({ name: "sales" });
    };

    const logout = async () => {
      try {
        await axios.get("/api/auth/logout", { withCredentials: true });
        router.push({ name: "login" });
      } catch (err) {
        console.error("Error fent logout:", err);
      }
    };

    return {
      isFullHeight,
      showNavbar,
      goVetlles,
      goSales,
      logout,
      isLoggedIn,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: $primary-bg-color;
  min-height: 100%;

  &--full-height {
    height: 100%;
  }
}

.page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2em;
  @media (max-width: 768px) {
    padding: 0;
  }

  &--full-height {
    padding: 0;
    height: 100%;
  }
}

.navbar {
  height: 4em;
  background-color: $primary-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1em;
}

.navbar-left,
.navbar-center,
.navbar-right {
  display: flex;
  align-items: center;
  gap: 1em;
  margin-right: 30px;
}

.logo-navbar {
  height: 3em;
}

.icon {
  color: $bg-color;
  font-size: 2em;

  transform: scale(1);
  transition: all 300ms ease-out;

  &:hover {
    cursor: pointer;
    transform: scale(1.2);
  }
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.4em;
  color: $bg-color;
  font-size: 0.9em;
  cursor: pointer;
  padding: 0.3em 0.6em;
  border-radius: 4px;
  transition: background-color 200ms ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.nav-icon {
  font-size: 1em;
}
</style>
